import { ArrowLeftOutlined, ClockCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Editor } from '@tinymce/tinymce-react';
import { Breadcrumb, Button, Col, Image, Row } from 'antd';
import { format, fromUnixTime } from 'date-fns';
import React, { useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLazyGetProcedureByIdQuery } from '../redux/ProcedureApi';
import { ReactComponent as Download } from '../../../assets/images/download.svg';
import { exportFile } from '../../common/ts/CommonFunctions';

const ProcedureDetail = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const [trigger, response] = useLazyGetProcedureByIdQuery();
    const params = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }, [])

    useEffect(() => {
        if (params.id && parseInt(params.id)) {
            trigger(parseInt(params.id));
        }
    }, [params, trigger])

    const downloadFile = (id: number, name: string) => {
        exportFile(process.env.REACT_APP_API_URL + `/files/downloadFile/${id}`, name);
    }

    return (
        <div
            ref={divRef}
            style={{
                // padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%',
                paddingTop: 40,
                paddingBottom: 40,
            }}
        >
            <div className="responsive-padding-1440">
                <Breadcrumb separator="  " className="custom-breadcrumb">
                    <Breadcrumb.Item>
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Thủ tục đấu giá
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div className="responsive-padding-1440" style={{ paddingTop: 25 }}>
                <div className="font-size-28 font-bold">{response.data?.title || ""}</div>
                <div style={{ marginTop: 40, display: 'flex' }}>
                    <div>
                        <ClockCircleOutlined style={{ marginRight: 5, fontSize: 16 }} />
                        {response.data?.createDate ? format(fromUnixTime(response.data?.createDate / 1000), "HH:mm - dd/MM/yyyy") : ""}
                    </div>
                </div>
                <div style={{ marginTop: 20 }} className="editor">
                    <Editor
                        tinymceScriptSrc="/tinymce/tinymce.min.js"
                        value={response.data?.content || ""}
                        init={{
                            menubar: false,
                            toolbar: false,
                            content_style: 'body { font-family:Times New Roman; font-size:13px; margin: 0 }',
                            contextmenu: false,
                            plugins: ['autoresize']
                        }}
                        disabled
                    />
                </div>

                <div style={{ marginTop: 10, letterSpacing: '0.1em', textAlign: 'center', fontSize: 16 }}>TÀI LIỆU ĐÍNH KÈM</div>

                <div style={{ marginTop: 20 }}>
                    <Row align='middle' justify='center' style={{ marginBottom: 10 }}>
                        <Col
                            style={{ overflow: 'auto', maxHeight: 500 }}
                            span={10}
                        >
                            {response.data?.files.length ?
                                response.data.files.map(item => {
                                    return (
                                        <Row
                                            key={item.id}
                                            style={{
                                                background: "#f9f9f9",
                                                borderRadius: 30,
                                                height: 50,
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '0px 30px',
                                                marginBottom: 10,
                                            }}
                                            className="custom-card-hover cursor-pointer"
                                            onClick={() => downloadFile(item.id, item.fileName)}
                                        >
                                            <Col
                                                span={18}
                                                className="font-size-16 font-bold"
                                                style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                                            >
                                                {item.fileName}
                                            </Col>
                                            <Col
                                                span={6}
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                <Download />
                                                <span style={{ marginLeft: 8, whiteSpace: 'nowrap' }} className="anchor-text">Tải xuống</span>
                                            </Col>
                                        </Row>
                                    )
                                })
                                : <></>}
                        </Col>
                    </Row>
                </div>

                {/* <div
                    style={{ marginTop: 55, textAlign: 'center', color: "#787885", fontSize: 12, cursor: 'pointer' }}
                    onClick={() => navigate("/procedure")}
                >
                    <ArrowLeftOutlined />
                    <span style={{ marginLeft: 6 }}>Thủ tục đấu giá</span>
                </div> */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button onClick={() => navigate("/procedure")} className="button-light-yellow" style={{ height: 45, width: 200 }} block htmlType="submit">Quay lại</Button>
                </div>
            </div>


        </div>
    )
}

export default ProcedureDetail;